import { FaSeedling, FaBookBible, FaUsers, FaChurch, FaArrowRight } from "react-icons/fa6";

const timeline = [
  {
    year: "2015",
    title: "A Humble Beginning",
    icon: <FaSeedling />,
    desc:
      "Moriah Church was founded with the pastor’s family and just 3–4 believers, united in prayer, faith, and a shared vision to serve God and proclaim the Gospel.",
  },
  {
    year: "2016–2018",
    title: "Laying the Foundation",
    icon: <FaBookBible />,
    desc:
      "The church focused on prayer, sound biblical teaching, and building strong relationships as God established the church spiritually and added members steadily.",
  },
  {
    year: "2019–2021",
    title: "Growth in Fellowship & Ministry",
    icon: <FaUsers />,
    desc:
      "As the congregation grew, ministries expanded with emphasis on discipleship, worship, and community fellowship, growing in unity and faith.",
  },
  {
    year: "2022–2024",
    title: "A Growing Church Family",
    icon: <FaChurch />,
    desc:
      "By God’s grace, the church became a vibrant congregation with strengthened youth, women, children, and prayer ministries.",
  },
  {
    year: "Present",
    title: "Continuing the Mission",
    icon: <FaArrowRight />,
    desc:
      "Today, Moriah Church is home to more than 120 members and continues to grow, remaining rooted in Scripture and committed to the Gospel.",
  },
];

export default function JourneyTimeline() {
  return (
    <section
      className="w-full bg-[#F5E9D8] px-6 py-20"
      data-aos="fade-up"
    >
      <div className="max-w-6xl mx-auto space-y-16">

        {/* Heading */}
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1F2B]">
            Our Journey
          </h2>
          <p className="mt-4 text-lg text-gray-700">
            A testimony of God’s faithfulness through every season.
          </p>
        </div>

        {/* Timeline cards */}
        <div className="grid md:grid-cols-5 gap-8">
          {timeline.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 text-center space-y-4 shadow-md hover:shadow-lg transition"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="flex justify-center text-3xl text-[#D9A05B]">
                {item.icon}
              </div>

              <span className="text-sm font-semibold uppercase tracking-widest text-[#D9A05B]">
                {item.year}
              </span>

              <h3 className="text-xl font-semibold text-[#1A1F2B]">
                {item.title}
              </h3>

              <p className="text-base leading-relaxed text-gray-700">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
